var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.74634 7.75587C4.07185 8.08138 4.59767 8.08138 4.92318 7.75587L11.2497 1.42097C11.5752 1.09546 11.5752 0.56964 11.2497 0.244131C10.9242 -0.0813771 10.3984 -0.0813771 10.0729 0.244131L4.33059 5.98644L1.92683 3.58268C1.60132 3.25717 1.0755 3.25717 0.749991 3.58268C0.424482 3.90819 0.424482 4.43401 0.749991 4.75952L3.74634 7.75587Z",
    fill: "white"
  })));
};
export default SvgCheck;